import React from 'react';
import 'react-day-picker/dist/style.css';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { PersistGate } from 'redux-persist/integration/react';
import App from './app';
import './assets/scss/index.scss';
import { ContextProvider } from './context/context';
import { persistor, store } from './redux/store';

import { SpeedInsights } from '@vercel/speed-insights/react';
import PageLoading from './components/pageLoading';
import { ReportContextProvider } from './context/report';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<PageLoading />} persistor={persistor}>
        <ContextProvider>
          <ReportContextProvider>
            <App />
            <SpeedInsights />
          </ReportContextProvider>
        </ContextProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
